export const PreviousLocationDiscarded: readonly RegExp[] = [/\/users\/.*\/general/, /\/users\/.*\/fleet/];
